export const CALENDLY_WIDGET = {
  DATA_URL: 'https://calendly.com/cosupport-alex/cosupport?hide_gdpr_banner=1',
  SCRIPT_SRC: 'https://assets.calendly.com/assets/external/widget.js',
};
